import * as React from 'react';
import { Popover } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useStyles } from '../style';

interface InfoPopoverProps {
    content: React.ReactNode;
    title?: string;
    trigger?: 'hover' | 'click' | 'focus';
    placement?: 'top' | 'left' | 'right' | 'bottom' | 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight' | 'leftTop' | 'leftBottom' | 'rightTop' | 'rightBottom';
    overlayStyle?: React.CSSProperties;
    iconSize?: number | string;
    iconStyle?: React.CSSProperties;
}

const InfoPopover: React.FC<InfoPopoverProps> = ({
    content,
    title,
    trigger = 'click',
    placement = 'right',
    overlayStyle = { width: 300, borderRadius: '4px' },
    iconSize,
    iconStyle,
}) => {
    const styles = useStyles();
    const iconStyles: React.CSSProperties = {
        ...(iconSize && { fontSize: typeof iconSize === 'number' ? `${iconSize}px` : iconSize }),
        ...iconStyle,
    };
    
    return (
        <Popover
            content={content}
            title={title}
            trigger={trigger}
            placement={placement}
            styles={{ root: overlayStyle }}
        >
            <InfoCircleOutlined className={styles.infoPopover} style={iconStyles} />
        </Popover>
    );
};

export default InfoPopover; 